import { render, staticRenderFns } from "./UserCreatorAgreeDialog.vue?vue&type=template&id=95564416&scoped=true"
import script from "./UserCreatorAgreeDialog.vue?vue&type=script&lang=js"
export * from "./UserCreatorAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./UserCreatorAgreeDialog.vue?vue&type=style&index=0&id=95564416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95564416",
  null
  
)

export default component.exports